/*
  Warenkorb-Drawer: Neuheiten mit einem Klick hinzufügen.
  Lädt anschließend den Drawer über Dawns Section Rendering neu.
*/
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-upsell-add]');
  if (!button) return;
  event.preventDefault();

  const item = button.closest('.cart-upsell__item');
  const variantInput = item && item.querySelector('[data-upsell-variant]');
  if (!variantInput || !variantInput.value) return;

  const drawer = document.querySelector('cart-drawer');
  button.disabled = true;
  button.classList.add('is-loading');
  button.textContent = 'Wird hinzugefügt …';

  try {
    const response = await fetch(`${window.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantInput.value), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    });
    const state = await response.json();
    if (!response.ok || state.status) throw new Error(state.description || state.message || 'Fehler');

    if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
      drawer.renderContents({ ...state, id: state.items && state.items[0] ? state.items[0].product_id : undefined });
    } else {
      window.location.reload();
    }
  } catch (error) {
    button.disabled = false;
    button.classList.remove('is-loading');
    button.textContent = 'Nicht verfügbar';
  }
});
